import { type Option } from '@redneckz/wildless-cms-uni-blocks/lib/ui-kit/Select/Option';

export const MONTHS: Option[] = [
  { text: 'Январь', key: '01' },
  { text: 'Февраль', key: '02' },
  { text: 'Март', key: '03' },
  { text: 'Апрель', key: '04' },
  { text: 'Май', key: '05' },
  { text: 'Июнь', key: '06' },
  { text: 'Июль', key: '07' },
  { text: 'Август', key: '08' },
  { text: 'Сентябрь', key: '09' },
  { text: 'Октябрь', key: '10' },
  { text: 'Ноябрь', key: '11' },
  { text: 'Декабрь', key: '12' },
];
